import { SightReductionProForma } from "../../ui/SightReductionProForma";

interface ProFormaProps {
  onNavigate: (to: string) => void;
}

/// Stand-alone page that hosts the printable sight-reduction worksheet.
/// The worksheet itself is reusable from the Reference tab too; this
/// page just gives it its own URL so a navigator can bookmark it.
export function ProForma({ onNavigate }: ProFormaProps) {
  return (
    <>
      <SightReductionProForma onBack={() => onNavigate("/play/astro")} />
    </>
  );
}
